import React, { Component, Fragment } from 'react';
import Navigation from '../components/Navigation';
import { translate } from 'react-i18next';
import axios from 'axios';
import {
    Panel,
    Col,
    Row,
    Button,
    FormControl,
    Form,
    FormGroup
} from 'react-bootstrap';
import PaginationPanel from '../components/PaginationPanel';
import config from '../config';
import qs from 'qs';
import TextRulesTable from '../components/TextRulesTable';
import { Link } from 'react-router-dom';
import Dialog from 'react-bootstrap-dialog';
import ReactPaginate from 'react-paginate';
import TooltipButton from '../components/TooltipButton';

import './TextRules.css';

class TextRules extends Component {
    constructor(props) {
        super(props);
        const { uuid } = this.props.match.params;

        this.state = {
            user: props.user,
            userIsAuthorized: props.userIsAuthorized,
            text: { heading: '', uuid: '' },
            rulegroups: null,
            page: props.page,
            limit: 1000,
            pageCount: 0,
            selected: props.selected - 1,
        };
    }

    deleteRule(rulegroup, rule) {
        var self = this;
        axios
            .delete(
                `${config.baseURL}/text/${this.state.text.uuid}/rulegroups/${
                    rulegroup.uuid
                }/rules/${rule.uuid}`
            )
            .then(function(result) {
                self.loadTextRuleGroupsFromServer();
            })
            .catch(function(err) {
                console.log(`Error deleting rule: ${rule} error: ${err}`);
            });
    }

    editRule(rulegroup, rule) {
        const {
            uuid,
            playerUUID,
            pageUUID,
            snippetUUID,
            textUUID
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;

        let link = `/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textsnippets/${snippetUUID}/texts/${textUUID}/rulegroups/${rulegroup.uuid}/rules/${
            rule.uuid
        }/edit?rel=player`;

        if (rel === 'snippet') {
            link = `/organisations/${uuid}/textsnippets/${snippetUUID}/texts/${textUUID}/rulegroups/${rulegroup.uuid}/rules/${
                rule.uuid
            }/edit?rel=snippet`;
        } else if (rel === 'page') {
            link = `/organisations/${uuid}/pages/${pageUUID}/textsnippets/${snippetUUID}/texts/${textUUID}/rulegroups/${rulegroup.uuid}/rules/${
                rule.uuid
            }/edit?rel=page`;
        }

        this.props.history.push(link);
    }

    componentDidMount() {
        this.loadTextFromServer();
        this.loadTextRuleGroupsFromServer();
    }

    loadTextFromServer() {
        const { textUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/text/${textUUID}`, {})
            .then(function(response) {
                self.setState({ text: response.data.text });
                self.loadOrganisationInformation();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadOrganisationInformation() {
        var self = this;

        const { uuid } = this.props.match.params;

        axios
            .get(`${config.baseURL}/organisations/${uuid}`, {})
            .then(function(response) {
                self.setState({
                    organisation_name: response.data.organisation.name
                });

                const parsed = qs.parse(
                    self.props.location.search.substring(1)
                );
                const rel = parsed.rel;
                if (rel === 'player') {
                    self.loadPlayerFromServer();
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadPlayerFromServer() {
        var self = this;
        const { playerUUID } = this.props.match.params;

        axios
            .get(`${config.baseURL}/players/${playerUUID}`, {})
            .then(function(response) {
                self.setState({
                    player_name: response.data.player.name
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    loadTextRuleGroupsFromServer() {
        const { textUUID } = this.props.match.params;

        let self = this;
        axios
            .get(`${config.baseURL}/text/${textUUID}/rulegroups`, {})
            .then(function(response) {
                if (
                    response.data.rulegroups &&
                    response.data.rulegroups.length > 0
                ) {
                    self.setState(
                        { rulegroups: response.data.rulegroups },
                        () => {
                            self.loadRuleGroupRulesFromServer();
                        }
                    );
                }
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handleChange = (event, rulegroup) => {
        const { textUUID } = this.props.match.params;

        const newOperator = event.target.value;

        let self = this;

        axios
            .patch(
                `${config.baseURL}/text/${textUUID}/rulegroups/${
                    rulegroup.uuid
                }`,
                {
                    name: rulegroup.name,
                    operator: newOperator
                }
            )
            .then(function(response) {
                self.loadTextRuleGroupsFromServer();

            })
            .catch(function(error) {
                console.log(error);
            });
    };

    loadRuleGroupRulesFromServer() {
        const { textUUID } = this.props.match.params;

        let self = this;

        let rulegroups = this.state.rulegroups;

        function getAllRules(rgs){
            return Promise.all(rgs.map(fetchRules));
        }
          
        function fetchRules(rulegroup) {
            return axios
              .get(`${config.baseURL}/text/${textUUID}/rulegroups/${rulegroup.uuid}/rules`,
                {
                    params: {
                        page: self.state.page,
                        limit: self.state.limit
                    }
                })
              .then(function(response) {
                
                rulegroup.rules = response.data.rules;

                return {
                    success: true,
                    rules: response.data.rules
                };

              })
              .catch(function(error) {
                return { success: false };
              });
        }

        getAllRules(rulegroups).then((resp) => {

            console.log(`Resp: ${JSON.stringify(resp)}`);
            
            self.setState({
                rulegroups
            });

        }).catch((e)=>{console.log(e)})
    }

    handleDeleteRuleGroupClicked(rulegroup) {
        var self = this;
        axios.delete(`${config.baseURL}/text/${this.state.text.uuid}/rulegroups/${rulegroup.uuid}/`)
            .then(function(result) {
                self.loadTextRuleGroupsFromServer();
            })
            .catch(function(error) {
                console.log(error);
            });
    }

    handleAddRuleGroup() {

        const { textUUID } = this.props.match.params;

        const ruleGroupProperties = {
            name: 'Rule Group',
            operator: 'AND'
        }

         let self = this;
            axios
                .post(
                    `${config.baseURL}/text/${
                        textUUID
                    }/rulegroups`,
                    ruleGroupProperties
                )
                .then(function(response) {
                    self.loadTextRuleGroupsFromServer();
                })
    }

    handlePageClick = data => {
        let selected = data.selected + 1;
        this.setState({ page: selected }, () => {
            this.loadPlayerAttributesFromServer();
        });
    };

    

    render() {
        const { t } = this.props;
        const {
            uuid,
            playerUUID,
            pageUUID,
            snippetUUID,
            textUUID
        } = this.props.match.params;

        const parsed = qs.parse(this.props.location.search.substring(1));
        const rel = parsed.rel;
        document.title = `MySign Digital Screen Solutions | ${t(
            'TextRules.title'
        )}`;


        let ruleGroupPanels = null;
        if (this.state.rulegroups && this.state.rulegroups.length > 0) {

            console.log(`RuleGroups: ${this.state.rulegroups}`);

            ruleGroupPanels = this.state.rulegroups.map((rulegroup, i) => {

                const {
                    uuid,
                    mediaLibraryUUID,
                    playerUUID,
                    pageUUID,
                    snippetUUID,
                    mediaUUID
                } = this.props.match.params;
        
                const parsed = qs.parse(this.props.location.search.substring(1));
                const rel = parsed.rel;
    
                console.log(`RuleGroup: ${JSON.stringify(rulegroup)}`);
    
                let createRuleLink = `/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textsnippets/${snippetUUID}/texts/${textUUID}/rulegroups/${rulegroup.uuid}/rules/create?rel=player`;

                if (rel === 'snippet') {
                    createRuleLink = `/organisations/${uuid}/textsnippets/${snippetUUID}/texts/${textUUID}/rulegroups/${rulegroup.uuid}/rules/create?rel=snippet`;
                } else if (rel === 'page') {
                    createRuleLink = `/organisations/${uuid}/pages/${pageUUID}/textsnippets/${snippetUUID}/texts/${textUUID}/rulegroups/${rulegroup.uuid}/rules/create?rel=page`;
                }
                
                return (
                    <>
                    <PaginationPanel
                                heading={
                                    <Form inline>
                                        <FormGroup>
                                            <h4
                                                style={{
                                                    display: 'inline'
                                                }}
                                            >
                                                {t('TextLibraryTextRules.show_if')}
                                            </h4>{' '}
                                            <FormControl
                                                className="select input-sm"
                                                componentClass="select"
                                                placeholder="Choose..."
                                                value={
                                                    rulegroup
                                                        .operator
                                                }
                                                onChange={(e) => this.handleChange(e, rulegroup)}
                                            >
                                                <option value="AND">
                                                    {t('TextLibraryTextRules.all')}
                                                </option>
                                                <option value="OR">
                                                    {t('TextLibraryTextRules.any')}
                                                </option>
                                            </FormControl>{' '}
                                            <h4
                                                style={{
                                                    display: 'inline'
                                                }}
                                            >
                                                {t(
                                                    'TextLibraryTextRules.of_the_rules_below_apply'
                                                )}
                                            </h4>
                    
                                        </FormGroup>
                                        {this.state.userIsAuthorized(
                                                this.state.user,
                                                [
                                                    'staff_super_admin',
                                                    'staff_admin',
                                                    'organisation_admin',
                                                    'organisation_user'
                                                ]
                                            ) ? (
                                            <div className="buttonContainer">
                                                <Link
                                                    type="submit"
                                                    className="btn btn-primary text-right addRule"
                                                    to={createRuleLink}
                                                
                                                >
                                                    <em className="fa fa-plus fa-fw" />{' '}
                                                    {t('TextLibraryTextRules.add_rule')}
                                                </Link> {' '}
                                                <TooltipButton
                                    tooltip={t(
                                        'TextLibraryTextRules.deleterulegroup'
                                    )}
                                    className="btn-danger "
                                    onClick={() =>
                                        this.handleDeleteRuleGroupClicked(rulegroup)
                                    }
                                >
                                    <em className="fa fa-trash" />
                                </TooltipButton>
                                            </div>
                                            ) : null}
                                    </Form>
                                    
                                }
                                pagination={
                                    (null)
                                }
                            >
                                        {/* console.log(`TextLibraryTextRulesTable: ${JSON.stringify(rulegroup)}`); */}
                                        <TextRulesTable
                                            userIsAuthorized={
                                                this.state.userIsAuthorized
                                            }
                                            user={this.state.user}
                                            rulegroup={rulegroup}
                                            rules={rulegroup.rules}
                                            mediaUUID={mediaUUID}
                                            onDelete={this.deleteRule.bind(this)}
                                            handleEditClicked={this.editRule.bind(
                                                this
                                            )}
                                            
                                        />
                                    </PaginationPanel>
                                    { i < this.state.rulegroups.length - 1 ? (

                                             <span className="label label-primary logicSeperator">
                                               <em className="fa fa-plus fa-fw logicSeperator" /> AND
                                            </span>

                                    ) : (null)}
                                    
                                    </>
                                   
                );
        }
        
            )};

        

       

        return (
            <div className="TextRules">
                <Dialog
                    ref={el => {
                        this.dialog = el;
                    }}
                />
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1 className="page-header">
                                    {t('TextRules.title')}
                                    {' - "'}
                                    {this.state.text.heading}
                                    {'" '}
                                    {rel === 'player' ? (
                                        <small>
                                            {this.state.player_name}{' '}
                                            <small
                                                style={{
                                                    whiteSpace: 'nowrap'
                                                }}
                                            >
                                                {this.state.organisation_name}
                                            </small>
                                        </small>
                                    ) : (
                                        <small>
                                            {this.state.organisation_name}
                                        </small>
                                    )}
                                    {this.state.userIsAuthorized(
                                        this.state.user,
                                        [
                                            'staff_super_admin',
                                            'staff_admin',
                                            'organisation_admin',
                                            'organisation_user'
                                        ]
                                    ) ? (
                                        <TooltipButton
                                        id=""
                                        className="btn btn-success"
                                        tooltip={t('MediaRules.add_rule_group')}
                                        onClick={() =>
                                            this.handleAddRuleGroup()
                                        }
                                    >
                                        <em className="fa fa-plus fa-fw" />{t('MediaRules.add_rule_group')}
                                    </TooltipButton>
                                    ) : null}
                                     {rel === 'player' ? (
                                        <>
                                        <a
                                            id="previewButton"
                                            type="submit"
                                            className="btn btn-success header-button"
                                            target="_blank"
                                            href={`${
                                                config.playersBaseURL
                                            }/mediaserver/unit.php?playerUUID=${playerUUID}&preview=1`}
                                        >
                                            <em className="fa fa-eye fa-fw" />{' '}
                                            {t('Player.preview_player')}
                                        </a>

                                        <a
                                            id="previewButton"
                                            type="submit"
                                            className="btn btn-warning header-button"
                                            target="_blank"
                                            href={`${
                                                config.playersBaseURL
                                            }/mediaserver/unit.php?playerUUID=${playerUUID}&preview=1&ignoreRules=1`}
                                        >
                                            <em className="fa fa-eye fa-fw" />{' '}
                                            {t('Player.preview_player_all')}
                                        </a>

                                        </>
                                    ) : null}
                                </h1>

                                <ol className="breadcrumb">
                                    {rel === 'player' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players`}
                                                >
                                                    {t(
                                                        'SideNavigation.players'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-tv" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}`}
                                                >
                                                    {t(
                                                        'OrganisationPlayer.title'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/`}
                                                >
                                                    {t('SideNavigation.pages')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}?rel=player`}
                                                >
                                                    {' '}
                                                    {t('Page.title')}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fa fa-font" />
                                                <Link
                                                    to={`/organisations/${uuid}/players/${playerUUID}/pages/${pageUUID}/textsnippets/${snippetUUID}?rel=player`}
                                                >
                                                    {' '}
                                                    {t('TextSnippet.title')}
                                                </Link>
                                            </li>{' '}
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('TextRules.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}

                                    {rel === 'snippet' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />
                                                <Link
                                                    to={`/organisations/${uuid}/snippets`}
                                                >
                                                    {' '}
                                                    {t(
                                                        'SideNavigation.globalsnippets'
                                                    )}
                                                </Link>
                                            </li>{' '}
                                            <li>
                                                <i className="fa fa-font" />
                                                <Link
                                                    to={`/organisations/${uuid}/textsnippets/${snippetUUID}?rel=snippet`}
                                                >
                                                    {' '}
                                                    {t('TextSnippet.title')}
                                                </Link>
                                            </li>
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('TextRules.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                    {rel === 'page' ? (
                                        <React.Fragment>
                                            <li>
                                                <i className="fa fa-tachometer-alt" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}`}
                                                >
                                                    {t('Dashboard.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-file" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages`}
                                                >
                                                    {t(
                                                        'SideNavigation.globalpages'
                                                    )}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-puzzle-piece" />{' '}
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}?rel=page`}
                                                >
                                                    {t('Page.title')}
                                                </Link>
                                            </li>
                                            <li>
                                                <i className="fa fa-font" />
                                                <Link
                                                    to={`/organisations/${uuid}/pages/${pageUUID}/textsnippets/${snippetUUID}?rel=page`}
                                                >
                                                    {' '}
                                                    {t('TextSnippet.title')}
                                                </Link>
                                            </li>{' '}
                                            <li className="active">
                                                <i className="fas fa-clipboard-list" />{' '}
                                                {t('TextRules.title')}
                                            </li>{' '}
                                        </React.Fragment>
                                    ) : null}
                                </ol>

                                {ruleGroupPanels}

                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default translate('translations')(TextRules);
